<mat-dialog-content class="mat-dialog-content">
<mat-tab-group mat-align-tabs="start" [(selectedIndex)]="this.helpPage">
<mat-tab label="Service Landscape Entity">
    <ng-template matTabContent>
    </ng-template>
</mat-tab>
<mat-tab label="Service Health Assessment Entity">
    <ng-template matTabContent>
    </ng-template>
</mat-tab>
<mat-tab label="Contribution Guidelines">
    <ng-template matTabContent>
    </ng-template>
</mat-tab>
<!-- <mat-tab label="FAQs">
    <ng-template matTabContent>
    </ng-template>
</mat-tab> -->
</mat-tab-group>

<div class="pdf" *ngIf="this.helpPage!=2">
    <pdf-viewer [show-all]="false" [page]="this.helpPage+1" [zoom]="0.8" src="assets/help/HelpPage.pdf"></pdf-viewer>
</div>
<div class="guidelines" *ngIf="this.helpPage==2">
    <table class="guidelinesTb">
        <ng-container *ngFor="let h of this.ContributionGuidelines.heads">
            <th>{{h}}</th>
        </ng-container>
        <ng-container *ngFor="let b of this.ContributionGuidelines.bodys">
            <tr>
                <td style="width:22%">{{b.what}}</td>
                <td style="width:78%">{{b.who}}</td>
            </tr>
        </ng-container>
    </table>
</div>
<!-- <div class="faq" *ngIf="this.helpPage==3">
    <app-table [tableDef]="FAQsDef"></app-table>
</div> -->

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="aip-button" (click)="close()" cdkFocusInitial>OK</button>    
</mat-dialog-actions>
